import { SET_TITLE, SET_MESSAGE, DELETE_MESSAGES } from './application.reducer'

export const setTitle = (title) => ({ type: SET_TITLE, title })

export const setMessage = (message, level) => ({ type: SET_MESSAGE, message, level })

export const deleteMessages = () => ({ type: DELETE_MESSAGES })
